import { render, staticRenderFns } from "./_icon-base.vue?vue&type=template&id=0dc310c4"
import script from "./_icon-base.vue?vue&type=script&lang=js"
export * from "./_icon-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports